/*
 * Title: SignedOutRedeemPage.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import RedeemTab component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import RedeemTab from "@containers/Profile/RedeemTab";
import * as React from "react";

type Props = {};

const ProfileRedeemPage: React.FC<Props> = (props) => {
  return <RedeemTab />;
};

export default ProfileRedeemPage;
